import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_CONTRACT} from '../../metamodel/Concept';

export default class ContractNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_CONTRACT;
	}
}
